import { api } from "@/lib/api";
import { ApiResponse, DocumentType, ErrorResponse } from "@/lib/types";
import { useMutation } from "@tanstack/react-query";

export const useUploadDocument = (props?: {
  onSuccess?: (data: ApiResponse<DocumentType>) => void;
  onError?: (error: ErrorResponse) => void;
}) => {
  return useMutation<ApiResponse<DocumentType>, ErrorResponse, FormData>({
    mutationKey: ["document-upload"],
    mutationFn: async (formData: FormData) => {
      const response = await api.post("/documents", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    },
    ...props,
  });
};
